export default {
  STRING: 'string',
  ENUMERATION: 'enumeration',
  NUMBER: 'number',
  DATE: 'date',
  DATE_TIME: 'datetime'
};